import type { Product } from '@/types'
import { deleteViewedProduct, deleteViewedProducts } from '@/utils/endpoint'
import { useState } from 'react'
import Slider from '../Slider/Slider'
import ViewedProduct from './ViewedProduct'

interface ViewedProductListProps {
  data: Product[]
  className?: string
}

const ViewedProductList = ({ data, className }: ViewedProductListProps) => {
  const [items, setItems] = useState(data)

  const handleDelete = (item: Product) => {
    setItems(items.filter(x => x !== item))
    deleteViewedProduct(item._id)
  }

  const handleDeleteAll = () => {
    setItems([])
    deleteViewedProducts()
  }

  if (!items?.length) {
    return null
  }

  return (
    <div
      className={`${className} recommend-product-list rounded-sm bg-white p-5`}
    >
      <div className='flex items-center justify-between'>
        <h3 className='px-1 text-xl font-semibold text-main'>
          Sản phẩm đã xem
        </h3>
        <button onClick={handleDeleteAll} className='text-sm text-sub'>
          Xoá lịch sử
        </button>
      </div>
      <div className='mt-4'>
        <Slider
          infinite={false}
          slidesToScroll={1}
          slidesToShow={4}
          centerMode={false}
          responsive={[
            {
              breakpoint: 1400,
              settings: { slidesToShow: 4 },
            },
            {
              breakpoint: 1200,
              settings: { slidesToShow: 3 },
            },
            {
              breakpoint: 768,
              settings: { slidesToShow: 2 },
            },
            {
              breakpoint: 576,
              settings: { slidesToShow: 1 },
            },
          ]}
        >
          {items.map(item => (
            <div className='px-2' key={item._id}>
              <ViewedProduct
                onDelete={handleDelete}
                data={item}
                className='w-full'
              />
            </div>
          ))}
        </Slider>
      </div>
    </div>
  )
}

export default ViewedProductList
